import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CyclistService } from '../../../../services/cyclist.service';
import { ServiceRequestService } from '../../../../services/servicerequest.service';
import { HelpersService } from '../../../../services/helpers.service';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { AnalyticsService } from '../../../../services/analytics.service';

@Component({
  selector: 'app-link-new-user',
  templateUrl: './link-new-user.component.html',
  styleUrls: ['./link-new-user.component.scss'],
})
export class LinkNewUserComponent implements OnInit {
  @Input() jobcard;
  @Input() partnerID;
  @Input() cyclist;
  @Input() messageService;
  @Output() cancel = new EventEmitter();
  @Output() relinked = new EventEmitter();

  public partnerData: any = {};
  public search: string = '';
  public cyclists: any = null;
  public selectedCyclist: any = {};
  public bikes: any = null;
  public selectedBike: any = {};
  public searching: boolean = false;
  public addNewCyclist: boolean = false;
  public eventID: any;
  public isWalkIn: boolean = false;
  public busy: boolean = true;

  constructor(
    public cyclistService: CyclistService,
    public analyticsService: AnalyticsService,
    public serviceRequestService: ServiceRequestService,
    public helpersService: HelpersService,
    private translate: TranslateService,
  ) {}

  ngOnInit() {
    let dateTime = new Date();
    this.eventID = dateTime.getTime().toString();
    this.analyticsService
      .SendTimings(
        this.jobcard.PartnerID,
        this.eventID,
        'Jobcard',
        'Relink Jobcard To Other Bike / User',
        '',
      )
      .subscribe((result) => {});

    this.partnerData = this.helpersService.getPartnerData();
    if (this.cyclist && this.cyclist.Email) {
      this.search = this.cyclist.Email;
      this.searchCyclist();
    }

    //Fit of a jippo for the spinner on the link jobcard button
    setTimeout(() => {
      this.busy = false;
    }, 500);
  }

  cancelRelink() {
    this.cancel.emit('');
  }

  relinkJobCard() {
    var data = {
      ID: this.jobcard.ID,
      BikeID: this.selectedBike.ID,
    };
    this.busy = true;
    this.serviceRequestService.relinkService(data).subscribe((result) => {
      this.relinked.emit(result);
    });
  }

  searchCyclist() {
    this.isWalkIn = false;
    this.cyclists = null;
    this.selectedCyclist = {};
    this.selectedBike = {};
    this.searching = true;
    this.addNewCyclist = false;
    this.cyclistService
      .searchCyclist(this.partnerID, this.search)
      .subscribe((cyclists) => {
        this.cyclists = [];
        cyclists.forEach((cyclist) => {
          this.cyclists.push({
            label:
              cyclist.Name + ' ' + cyclist.Surname + ' (' + cyclist.Email + ')',
            value: cyclist,
          });
        });
        if (this.cyclists.length > 0) {
          this.selectedCyclist = this.cyclists[0].value;
          this.getBikes();
        } else {
          this.selectedBike = {};
          this.bikes = [];
          this.searching = false;
        }
      });
  }

  getBikes() {
    this.selectedBike = {};
    this.cyclistService
      .getActiveBikesForCyclistAndPartner(
        this.selectedCyclist.ID,
        this.partnerData.ID,
      )
      .subscribe((bikes) => {
        this.searching = false;
        this.bikes = [];
        bikes.forEach((bike) => {
          this.bikes.push({ label: bike.Manufacturer+" "+bike.Model, value: bike });
        });
        if (this.bikes.length > 0) {
          this.selectedBike = this.bikes[0].value;
        }
      });
  }

  addCyclist() {
    this.search = '';
    this.selectedCyclist = {};
    this.selectedBike = {};
    this.cyclists = null;
    this.bikes = null;

    setTimeout(() => {
      this.cyclists = [];
      this.bikes = [];
      this.addNewCyclist = true;
      this.searching = false;
    }, 1000);
  }

  newCyclist(event) {
    console.log(event);
    if (event.searchAgain) {
      this.search = event.cyclist.Email;
      this.searchCyclist();
    } else {
      this.selectedBike = event.bike;
      this.selectedCyclist = event.cyclist;
      if (this.selectedBike && this.selectedCyclist) {
        this.relinkJobCard();
      } else {
        this.search = event.cyclist.Email;
        this.searchCyclist();
      }
    }
  }

  addBike() {
    this.selectedBike = {};
    this.bikes = [];
    this.addNewCyclist = true;
    this.searching = false;
  }
}
